import React from 'react'
import { BasicStatsItem } from '../index.styles'

const ArchiveDigitalization = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiYTg0NmRiM2UtMmI3My00NWQ5LWEzNzAtYmI4MTZlYjI1YTUwIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="archive-digitalization iframe" src={link} />
    </BasicStatsItem>
  )
}

export default ArchiveDigitalization